import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderService } from '@/services/header-service.interface';
import { clientDeferred } from '@eureka/utils/client';
import { controlDeferred } from '@eureka/utils/control';

export const HeaderServiceProxy = Symbol('HeaderServiceProxy');

export interface HeaderServiceProxy {
  headerService: HeaderService;
}

@injectable()
export class HeaderServiceProxyImpl implements HeaderServiceProxy {
  constructor(
    @inject(HeaderService)
    public headerService: HeaderService,
  ) {
    this.headerService.visibleProducts = false;
    Promise.all([clientDeferred.promise, controlDeferred.promise]).then(
      ([clientRes, controlRes]) => {
        this.headerService.deferred.promise.then(() => {
          this.headerService.visibleProducts = !clientRes.isFeiShu && !controlRes.freemium;
        });
      },
    );
  }
}
